import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes =  [
  {
    path: "/",
    name: "main",
    component: () => import("./views/Main.vue"),
    children: [
      {
        path: "",
        name: 'home',
        component: () => import("./views/Home.vue")
      },
      {
        path: "/role",
        name: "role",
        component: () => import("./views/sys/Role.vue")
      },
      {
        path: "/manager",
        name: "manager",
        component: () => import("./views/sys/Manager.vue")
      },
      {
        path: "/nav",
        name: "nav",
        component: () => import("./views/sys/Nav.vue")
      },
      {
        path: "/navigation",
        name: "navigation",
        component: () => import("./views/sys/Navigation")
      },
      {
        path: "/siteconfig",
        name: "siteconfig",
        component: () => import("./views/sys/SiteConfig.vue")
      },
      {
        path: "/banner",
        name: "banner",
        component: () => import("./views/sys/Banner.vue")
      },
      {
        path: "/articleInfo",
        name: "articleInfo",
        component: () => import("./views/sys/ArticleInfo.vue")
      },
      {
        path: "/articleStatic/:id",
        name: "articleStatic",
        component: () => import("./views/sys/ArticleStatic.vue"),
      },
      {
        path: "/newsCate",
        name: "newsCate",
        component: () => import("./views/Other/newsCate.vue")
      },
      {
        path: "/newsInfo",
        name: "newsInfo",
        component: () => import("./views/Other/newsInfo.vue")
      },      
      {
        path: "/courseCate",
        name: "courseCate",
        component: () => import("./views/Other/CourseCate.vue")
      },      
      {
        path: "/inquiry",
        name: "inquiry",
        component: () => import("./views/sys/Inquiry.vue")
      }, 
      {
        path: "/courseInfo",
        name: "courseInfo",
        component: () => import("./views/Other/CourseInfo.vue")
      },
      {
        path: "/honor",
        name: "honor",
        component: () => import("./views/Other/Honor.vue")
      },      
      {
        path: "/teach",
        name: "teach",
        component: () => import("./views/Other/Teach.vue")
      },      
      {
        path: "/teacher",
        name: "teacher",
        component: () => import("./views/Other/Teacher.vue")
      },
    ]
  },
  {
    path: "/login",
    name: "login",
    component: () => import("./views/Login.vue")
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
